import { render } from "./preLoader.vue?vue&type=template&id=6a6341e3&scoped=true"
const script = {}

import "./preLoader.vue?vue&type=style&index=0&id=6a6341e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6341e3"]])

export default __exports__